import { GetAllPlacesFromGroupUseCaseInterface } from 'domain/usecases';
import { TableColumn } from 'react-data-table-component';

export const makeColumnsGroupSettingsInternshipLocationsList = (): TableColumn<
  GetAllPlacesFromGroupUseCaseInterface.Result[number]
>[] => {
  return [
    {
      name: 'Nome',
      wrap: true,
      sortable: true,
      selector: (row) => row.name,
    },
  ];
};
